module.exports = "<h1>Api Docs</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/api-docs/api-docs.component.html
// module id = 570
// module chunks = 0